// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610011304/js/" + chunkId + "." + {"44":"d5bc866d","225":"c7638352","481":"81834027","486":"4d21b963","770":"9481ac5d"}[chunkId] + ".0.7626570708683948.chunk.js";
};